<template>
    <div id="app">
      <Transition name="fade">
        <!-- <p>lang: {{ this.$route.params.lang }}</p> -->
        <router-view/>
      </Transition>
    </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert2'
import i18n from '@/plugins/i18n';

axios.interceptors.response.use(response => {
  return response;
 }, error => {
 if (error.response && error.response.data) {
   console.warn(JSON.stringify(error));
   // Hvis errorHandle er sat til false, så lad ikke interceptoren vise fejlbesked, så vi kan vise en cusom fejl istedet
   if(error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
     console.warn('errorHandle: false');
     return Promise.reject(error);
   } else {
     console.log('errorHandle: true');
     // handle your errors here.
     //alert(error.response.data.message);
     swal.fire({
       icon: 'error',
       title: 'Generisk Fejl!',
       text: error.response.data.message,
       showCloseButton: true,
       showConfirmButton: false,
     })
   }
 }
});


export default {
  data() {
    return {
      refCount: 0,
      isLoading: false,
      locale: i18n.locale,
    };
  },
  created() {
    // Sæt 'loading' til true når vi sender et axios request, sæt den til 'false' når vi får et svar eller en fejl
    axios.interceptors.request.use((config) => {
      // trigger 'loading=true' event here
      this.$store.dispatch("toggleLoading", true);
      return config;
    }, (error) => {
      // trigger 'loading=false' event here
      this.$store.dispatch("toggleLoading", false);
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      // trigger 'loading=false' event here
      this.$store.dispatch("toggleLoading", false);
      return response;
    }, (error) => {
      // trigger 'loading=false' event here
      this.$store.dispatch("toggleLoading", false);
      return Promise.reject(error);
    });


/*     var vm = this;
    if(!vm.locale) {
      this.$router.replace({ path: "/da" });
    } else {
      console.log("Router: " . vm.locale);
    }
 */
},
  methods: {
    setLoading(isLoading) {
      if (isLoading) {
        this.refCount++;
        this.isLoading = true;
      } else if (this.refCount > 0) {
        this.refCount--;
        this.isLoading = (this.refCount > 0);
      }
    },
  } 
}

</script>


<style>
#app {
  font-family: 'Roboto Condensed';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;
}

/* body {
  height: 100%;
  margin: 0;
  background-image: linear-gradient(#004072 25%, #CDCBCB);
  background-attachment: fixed;
  background-repeat: no-repeat;
}
 */

html {
  height: auto;
  min-height: 100%;
}

body {
  height: auto;
  min-height: 100%;
  margin: 0;
  background: #004072;
  background: linear-gradient(#004072 25%, #CDCBCB);
  background: -moz-linear-gradient(#004072, #CDCBCB); /* FF 3.6+ */  
  background: -ms-linear-gradient(#004072, #CDCBCB); /* IE10 */  
  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #004072), color-stop(100%, #CDCBCB)); /* Safari 4+, Chrome 2+ */  
  background: -webkit-linear-gradient(#004072, #CDCBCB); /* Safari 5.1+, Chrome 10+ */  
  background: -o-linear-gradient(#004072, #CDCBCB); /* Opera 11.10 */  
  z-index: 1;
  

  background-attachment: fixed;
  background-repeat: no-repeat;
}

.hotelButton {
  display: flex;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0px;
    -webkit-box-shadow: 0px 4px 4px #666666;
    -moz-box-shadow: 0px 4px 4px #666666;
    box-shadow: 0px 10px 20px #666666;
    color: #000000;
    font-size: 30px;
    /* background-color: rgba(255,255,255,0.87); */
    background-color: rgba(239,244,251,.77);
    width: 330px;
    height: 150px;
    box-sizing: border-box;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 250%;
    align-items: center;
    justify-content: center;
    padding-left: 10px;
    padding-right: 10px;

  }
.hotelButton:hover {
    background-color: rgba(255,255,255,0.95);
    text-decoration: none;
    text-transform: uppercase;
  }


.arrow {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-top: 2px solid white;
  border-right: 2px solid white;
  margin-top: 25px;
  margin-left: 15px;
  display: flex;
  align-content:flex-start;
}

.arrow-left {
  transform: rotate(-135deg);
}

/* Styling af transition imellem sider */
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.5s;
}

.fade-enter-active {
  transition-delay: 0.0s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}


</style>
